export default {
  STRIP_COLUMNS_CONTAINER: 'db37c9b4-c003-4730-8e81-a4c5029122ee',
};
